import React, { useEffect, useMemo, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useQuery, useMutation } from 'react-apollo';
import propTypes from 'prop-types';
import gql from 'graphql-tag';

import useMe from '../../hooks/useMe';
import CustomHeader from '../../components/CustomHeader';
import useToast from '../../hooks/useToast';
import useContext from '../../hooks/useContext';

const getGql = gql`
  query condominium($slug: String!) {
    condominium(slug: $slug) {
      _id
      name
    }
  }
`;
const addUserCondominiumGql = gql`
  mutation addUserCondominium($condominiumId: ID!, $unity: String!) {
    addUserCondominium(condominiumId: $condominiumId, unity: $unity) {
      name
    }
  }
`;

export default function AddCondominium({ history }) {
  const [me, fetchMe] = useMe();
  const { write } = useContext();
  const params = useParams();
  const toast = useToast();
  const [unity, setUnity] = useState('');
  const { data, loading } = useQuery(getGql, {
    skip: !me || !params.referral,
    variables: {
      slug: params.referral,
    },
  });

  const condominium = useMemo(() => {
    if (!data) return {};

    return data.condominium;
  }, [data]);

  const [addUserCondominiumFn] = useMutation(addUserCondominiumGql, {
    onCompleted: async ({ addUserCondominium }) => {
      write({
        condominiumId: condominium._id,
        callback: () => {
          toast.fire({
            icon: 'success',
            title: `Bem vindo(a) ${addUserCondominium.name}`,
          });
          history.push('/dashboard');
        },
      });
    },
    onError: () =>
      toast.fire({
        icon: 'error',
        title: 'Problemas ao registrar. Tente novamente',
      }),
  });

  useEffect(() => {
    if (
      me &&
      data &&
      me.condominiums &&
      me.condominiums.find(
        x => x.data === data.condominium._id && x.status === 'approved',
      )
    ) {
      write({
        condominiumId: data.condominium._id,
        callback: () => {
          toast.fire({
            icon: 'warning',
            text: 'Você já possui acesso a este condomínio',
          });
          history.push('/dashboard');
        },
      });
    }
  }, [data, me]);

  const hasRejection = useMemo(
    () =>
      me?.condominiums?.find(
        x => x.data === data?.condominium?._id && x.status === 'rejected',
      ),
    [me, data],
  );

  const handleAccept = () => {
    addUserCondominiumFn({
      variables: {
        condominiumId: condominium._id,
        unity,
      },
    });
  };

  useEffect(() => {
    fetchMe();
  }, []);
  return (
    <div className="dashboard h-100 d-flex flex-column">
      {loading ? (
        <div className="justify-content-center d-flex p-3">
          <h4>Carregando</h4>
        </div>
      ) : (
        <>
          <CustomHeader
            title={
              hasRejection
                ? condominium.name
                : `Solicitar acesso a ${condominium.name}`
            }
          />
          {hasRejection ? (
            <div className="d-flex flex-column">
              <div className="d-flex align-self-center mb-3 font-weight-bold">
                Sua solicitação foi recusada
              </div>
              <div>Solicitar participação novamente</div>
            </div>
          ) : (
            <b>{`Informe sua unidade para participar das assembleias do ${condominium.name}`}</b>
          )}

          <div className="d-flex flex-column mt-4">
            <div className="form-group">
              <label>Unidade do condomínio</label>
              <div className="input-group row">
                <div className="col-5 ">
                  <input
                    className="form-control form-control-lg"
                    placeholder="unidade"
                    value={unity || ''}
                    onChange={e => setUnity(e.target.value)}
                  />
                  <small>Exemplo: Apto + Bloco</small>
                </div>
              </div>
            </div>
            <button
              onClick={handleAccept}
              className="btn btn-lg btn-success mt-2 text-white mr-1"
              type="button"
              disabled={!unity}
            >
              Solicitar acesso
            </button>
            <Link to="/dashboard" className="text-center mt-5">
              Não desejo adicionar o condomínio
            </Link>
          </div>
        </>
      )}
    </div>
  );
}

AddCondominium.propTypes = {
  history: propTypes.object.isRequired,
};
